<template>
    <section class="filterContainer">
        <!-- <b-form-input type="text" v-model="searchText" placeholder="Pesquisar"></b-form-input> -->
        <div class="switchGroup" v-if="showStatusSwitches">
            <label>{{ registroLabel }}</label>
            <div>
                <b-form-checkbox v-model="statusPendente" name="check-status-pendente" switch @input="emitFilters">
                    Pendente
                </b-form-checkbox>
                <Counter :value="statusCounts.pendente" />
            </div>
            <div>
                <b-form-checkbox v-model="statusRtaGerada" name="check-status-rta-gerada" switch @input="emitFilters">
                    RTA Gerada
                </b-form-checkbox>
                <Counter :value="statusCounts.rta_gerada" />
            </div>
            <div>
                <b-form-checkbox v-model="statusJustificada" name="check-status-justificada" switch @input="emitFilters">
                    Justificada
                </b-form-checkbox>
                <Counter :value="statusCounts.justificada" />
            </div>
        </div>
        <div class="filters-row">
            <SearchableSelect
            class="filter-select"
            :extraClass="highlightSelect ? 'input-pentagro' : ''"
            :modelRef="processId"
            :optList="processOptions"
            optValue="id"
            optDisplay="description"
                :inputFunc="handleProcessChange"
            placeholder="Selecione o processo"
        />
        <SearchableSelect
            class="filter-select"
                :extraClass="highlightSelect ? 'input-pentagro' : ''"
            :modelRef="workshiftId"
            :optList="workshiftOptions"
            optValue="id"
            optDisplay="description"
                :inputFunc="handleWorkshiftChange"
            placeholder="Selecione o turno"
        />
            <searchDatePicker :lang="ptbr" :shortcuts="shortcuts" v-model="customInterval" class="custom-date" type="date"
                format="DD/MM/YYYY" range placeholder="Intervalo da busca" range-separator="  até  ">
                <template v-slot:input="slotProps">
                    <input type="text" v-bind="slotProps.props" v-on="slotProps.events" />
                </template>

                <template v-slot:icon-calendar>
                    <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512">
                        <path
                            d="M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm64 80v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm128 0v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H336zM64 400v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H336c-8.8 0-16 7.2-16 16z" />
                    </svg>
                </template>
            </searchDatePicker>
            <button @click="emitFilters" class="btn-trigger">
                <b-icon-search></b-icon-search>
                <span>Buscar</span>
            </button>
            <button class="reset" @click="resetFilters">
                <span>Resetar Busca</span>
            </button>

            <div class="buttons-row" v-if="showActionButtons">
                <button @click="handleGerarRta" class="btn-trigger">
                    <span>Gerar RTA</span>
                </button>
                <button @click="handleVincularRta" :disabled="loadingLinkRta" class="btn-trigger">
                    <b-spinner small v-if="loadingLinkRta"></b-spinner>
                    <span>{{ loadingLinkRta ? 'Carregando...' : 'Vincular RTA' }}</span>
                </button>
                <button class="btn-trigger" @click="handleJustificar">
                    <span>Justificar</span>
                </button>
            </div>

            <div class="exportBtns" v-if="showExport">
            <button @click="exportExcel" v-if="!isGraph">
                <b-icon-file-earmark-excel-fill />
                <span>
                    Exportar Excel
                </span>
            </button>

            <button @click="exportPdf">
                <b-icon-file-earmark-pdf-fill />
                <span>
                    Exportar PDF
                </span>
            </button>

            </div>
        </div>
    </section>
</template>

<script>
import searchDatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import ptbr from 'vue2-datepicker/locale/pt-br';
import * as moment from 'moment';
import axios from 'axios';
import { urlMainAPI } from '../../../global';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import SearchableSelect from "./SearchableSelect.vue";
import Counter from '@/components/template/Counter.vue';

export default {
    name: "RTAFilters",
    components: { searchDatePicker, SearchableSelect, Counter },
    props: {
        listToFilter: {
            type: Array,
            require: true
        },
        headerToExport: {
            type: Array,
            require: true,
        },
        dataToExport: {
            type: Array,
            require: true,
        },
        fileName: {
            type: String,
            require: true
        },
        showExport: {
            type: Boolean,
            require: true
        },
        highlightSelect: {
            type: Boolean,
            default: false
        },
        isGraph: {
            type: Boolean,
            require: false
        },
        statusCountsProp: {
            type: Object,
            require: false,
            default: () => ({
                pendente: 0,
                rta_gerada: 0,
                justificada: 0
            })
        },
        showStatusSwitches: {
            type: Boolean,
            require: false,
            default: false
        },
        showActionButtons: {
            type: Boolean,
            require: false,
            default: false
        },
        loadingLinkRta: {
            type: Boolean,
            require: false,
            default: false
        }
    },

    computed: {
        registroLabel() {
            return 'Registro(s) Selecionado(s):';
        }
    },

    data() {
        // Se vier do monitoramento (com indicatorId), não inicializa com data padrão
        const hasIndicatorId = this.$route.params.indicatorId;

        return {
            ptbr: {
                ...ptbr,
                monthFormat: 'MMMM'
            },
            customInterval: hasIndicatorId ? [] : [moment().subtract(7, 'days').startOf('day').toDate(),
            moment().endOf('day').toDate()],
            searchText: null,
            processOptions: [],
            processId: null,
            workshiftOptions: [],
            workshiftId: null,
            statusPendente: false,
            statusRtaGerada: false,
            statusJustificada: false,
            statusCounts: {
                pendente: 0,
                rta_gerada: 0,
                justificada: 0
            },
            filtersStorageKey: 'rta-list-filters',
            shortcuts: [
                {
                    text: 'Hoje',
                    onClick: () => {
                        this.customInterval = [new Date(), new Date()];
                    }
                },
                {
                    text: '2 dias',
                    onClick: () => {
                        let two = new Date();
                        two.setDate(two.getDate() - 1)
                        this.customInterval = [two, new Date()];
                    }
                },
                {
                    text: '3 dias',
                    onClick: () => {
                        let three = new Date();
                        three.setDate(three.getDate() - 2)
                        this.customInterval = [three, new Date()];
                    }
                },
                {
                    text: '5 dias',
                    onClick: () => {
                        let five = new Date();
                        five.setDate(five.getDate() - 4)
                        this.customInterval = [five, new Date()];
                    }
                },
                {
                    text: '7 dias',
                    onClick: () => {
                        let seven = new Date();
                        seven.setDate(seven.getDate() - 6)
                        this.customInterval = [seven, new Date()];
                    }
                },
                {
                    text: '15 dias',
                    onClick: () => {
                        let fifteen = new Date();
                        fifteen.setDate(fifteen.getDate() - 14)
                        this.customInterval = [fifteen, new Date()];
                    }
                }
            ]
        }
    },
    methods: {
        emitFilters() {
            if (this.customInterval[0] == null || this.customInterval[1] == null) {
                this.customInterval = [moment().subtract(7, 'days').startOf('day').toDate(),
                moment().endOf('day').toDate()];
            }
            const filters = {
                searchText: this.searchText,
                processId: this.processId,
                workshiftId: this.workshiftId,
                startDate: moment(this.customInterval[0]).format("YYYY-MM-DD 00:00:00"),
                endDate: moment(this.customInterval[1]).format("YYYY-MM-DD 23:59:59"),
                statusPendente: this.statusPendente,
                statusRtaGerada: this.statusRtaGerada,
                statusJustificada: this.statusJustificada,
            };
            this.saveFilters();
            this.$emit("filter-changed", filters);
        },
        resetFilters() {
            this.searchText = null;
            this.processId = null;
            this.workshiftId = null;
            this.statusPendente = true;
            this.statusRtaGerada = false;
            this.statusJustificada = false;
            this.customInterval = [moment().subtract(7, 'days').startOf('day').toDate(),
            moment().endOf('day').toDate()];
            this.clearSavedFilters();
            this.$emit("filter-reset");
        },

        saveFilters() {
            try {
                // Não salva filtros se houver indicatorId na rota (vindo do monitoramento)
                if (this.$route.params.indicatorId) {
                    return;
                }

                const filtersToSave = {
                    processId: this.processId,
                    workshiftId: this.workshiftId,
                    customInterval: this.customInterval,
                    timestamp: new Date().getTime()
                };
                localStorage.setItem(this.filtersStorageKey, JSON.stringify(filtersToSave));
            } catch (error) {
                console.error('Erro ao salvar filtros no localStorage:', error);
            }
        },

        loadSavedFilters() {
            try {
                const savedFilters = localStorage.getItem(this.filtersStorageKey);
                if (savedFilters) {
                    const filters = JSON.parse(savedFilters);
                    this.processId = filters.processId;
                    this.workshiftId = filters.workshiftId;

                    if (filters.customInterval && filters.customInterval.length === 2) {
                        this.customInterval = [
                            new Date(filters.customInterval[0]),
                            new Date(filters.customInterval[1])
                        ];
                    }

                    return true;
                }
            } catch (error) {
                console.error('Erro ao carregar filtros do localStorage:', error);
            }
            return false;
        },

        clearSavedFilters() {
            try {
                localStorage.removeItem(this.filtersStorageKey);
            } catch (error) {
                console.error('Erro ao limpar filtros do localStorage:', error);
            }
        },

        handleProcessChange(event) {
            this.processId = event.target.value;
        },

        handleWorkshiftChange(event) {
            this.workshiftId = event.target.value;
        },

        async loadProcess() {
            await axios.get(`${urlMainAPI}/getprocess`)
                .then(res => {
                    this.processOptions = res.data;
                    this.processOptions.unshift({ value: null, description: "Selecione o processo", id: null })
                }).catch(err => console.error(err))
        },

        async loadWorkshift() {
            await axios.get(`${urlMainAPI}/getworkshift`)
                .then(res => {
                    this.workshiftOptions = res.data;
                    this.workshiftOptions.unshift({ value: null, description: "Selecione o turno", id: null });
                }).catch(err => console.error(err))
        },

        async exportExcel() {
            if (this.isGraph == true) this.graphExcel();
            else this.tableExcel();
        },

        async exportPdf() {
            if (this.isGraph == true) this.graphPdf();
            else this.tablePdf();
        },

        async tablePdf() {
            const doc = new jsPDF({
                orientation: 'landscape',
                compress: true
            });
            autoTable(doc, {
                headStyles: { valign: 'middle' },
                head: [
                    this.headerToExport.map(x => x.title)
                ],
                body: this.dataToExport.map(item => this.headerToExport.map(c => item[c.field])),
            });
            doc.save(`${this.fileName} - ${new Date().getDate()}/${new Date().getMonth() + 1}/${new Date().getFullYear()}.pdf`);
        },

        async tableExcel() {
            let baseDoc = this.GenerateBaseTable();

            let workbook = XLSX.utils.book_new();

            const worksheet = XLSX.utils.json_to_sheet(baseDoc);
            XLSX.utils.book_append_sheet(workbook, worksheet, this.fileName);

            XLSX.writeFile(workbook, `${this.fileName} - ${new Date().getDate()}/${new Date().getMonth() + 1}/${new Date().getFullYear()}.xlsx`);
        },

        GenerateBaseTable() {
            let formattedTable = [];

            this.dataToExport.forEach(d => {
                let rowToAdd = {};
                this.headerToExport.forEach(h => {
                    rowToAdd[h.title] = d[h.field]
                })
                formattedTable.push(rowToAdd);
            }
            );

            return formattedTable;
        },

        async graphPdf() {
            const statusImg = await this.getChartImage(this.dataToExport[0].statusGraph);
            const respImg = await this.getChartImage(this.dataToExport[0].respGraph);
            const indImg = await this.getChartImage(this.dataToExport[0].indGraph);
            const efficImg = await this.getChartImage(this.dataToExport[0].efficGraph);


            const doc = new jsPDF({
                unit: "px",
                format: "a4",
                orientation: "portrait"
            });

            doc.setFont("helvetica", "bold");
            doc.setFontSize(20);
            doc.setTextColor(30, 30, 30);

            doc.setFontSize(18);
            doc.setTextColor(40, 40, 40);
            doc.text("Relatório de Gráficos - Análise de RTAs", doc.internal.pageSize.width / 2, 40, { align: "center" });

            const marginX = 30;
            const chartWidth = doc.internal.pageSize.width - 2 * marginX;
            const chartHeight = 220;

            doc.addImage(statusImg, "PNG", marginX, 60, chartWidth, chartHeight);
            doc.addImage(respImg, "PNG", marginX, 300, chartWidth, chartHeight);

            doc.addPage();
            doc.text("Relatório de Gráficos - Análise de RTAs", doc.internal.pageSize.width / 2, 40, { align: "center" });

            doc.addImage(indImg, "PNG", marginX, 60, chartWidth, chartHeight);
            doc.addImage(efficImg, "PNG", marginX, 300, chartWidth, chartHeight);

            await doc.save("charts.pdf", {
                returnPromise: true
            });
        },

        loadImage(src) {
            return new Promise((resolve, reject) => {
                const img = new Image();
                img.onload = () => resolve(img);
                img.onerror = reject;
                img.src = src;
            });
        },

        getChartImage(chart) {
            return this.loadImage(chart.$children[0].getDataURL());
        },

        async graphExcel() {
            let workbook = XLSX.utils.book_new();

            let worksheet = XLSX.utils.aoa_to_sheet([]);

            const title = "Relatório de Gráficos - Análise de RTAs";
            XLSX.utils.sheet_add_aoa(worksheet, [[title]], { origin: "A1" });

            worksheet["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 4 } }];
            worksheet["A1"].s = {
                font: { bold: true, sz: 16 },
                alignment: { horizontal: "center", vertical: "center" }
            };

            const statusGraph = await this.getChartImage(this.dataToExport[0].statusGraph);
            const respGraph = await this.getChartImage(this.dataToExport[0].respGraph);
            const indGraph = await this.getChartImage(this.dataToExport[0].indGraph);
            const efficGraph = await this.getChartImage(this.dataToExport[0].efficGraph);

            let rowOffset = 2;

            const graphs = [
                { title: "RTAs por Status", img: statusGraph },
                { title: "RTAs por Responsável", img: respGraph },
                { title: "RTAs Abertas por Indicador", img: indGraph },
                { title: "Avaliação de RTAs e Plano de Ações", img: efficGraph }
            ];

            graphs.forEach((graph) => {
                XLSX.utils.sheet_add_aoa(worksheet, [[graph.title]], { origin: `A${rowOffset}` });

                worksheet[`A${rowOffset}`].s = {
                    font: { bold: true, sz: 14 },
                    alignment: { horizontal: "center", vertical: "center" }
                };

                rowOffset += 20;
            });

            worksheet["!cols"] = [{ wpx: 300 }, { wpx: 500 }];

            XLSX.utils.book_append_sheet(workbook, worksheet, "Gráficos");

            XLSX.writeFile(workbook, `Relatório_Graficos_${new Date().toISOString().slice(0, 10)}.xlsx`);
        },

        handleGerarRta() {
            this.$emit('gerar-rta-clicked');
        },

        handleVincularRta() {
            this.$emit('vincular-rta-clicked');
        },

        handleJustificar() {
            this.$emit('justificar-clicked');
        },
    },

    watch: {
        statusCountsProp: {
            handler(newVal) {
                if (newVal) {
                    this.statusCounts = { ...newVal };
                }
            },
            deep: true,
            immediate: true
        }
    },

    async mounted() {
        await this.loadProcess();
        await this.loadWorkshift();

        // Não carrega filtros salvos se houver indicatorId na rota
        const hasIndicatorIdInRoute = this.$route.params.indicatorId;

        if (hasIndicatorIdInRoute) {
            // Limpa as datas quando vem do monitoramento
            this.customInterval = [];
        } else {
            this.loadSavedFilters();

            // Sempre emite os filtros, seja do localStorage ou os padrões (últimos 7 dias)
            this.$nextTick(() => {
                this.emitFilters();
            });
        }
    },
}

</script>

<style scoped>
.filterContainer {
    margin: 0.8rem 0;
    display: flex;
    flex-direction: column;
    row-gap: 0.8rem;
}

.switchGroup {
    display: flex;
    justify-content: flex-start;
    gap: 15px;
    min-width: 620px;
}

.switchGroup label {
    font-size: 0.9em;
}

.filters-row {
    display: flex;
    column-gap: 0.5rem;
    align-items: center;
}

.buttons-row {
    display: flex;
    column-gap: 0.5rem;
    align-items: center;
    margin-left: auto;
    margin-right: auto;
}

.filterContainer input,
.filterContainer select,
.filterContainer .select-shell {
    max-width: 15rem;
    width: 15rem;
}

.filterContainer .custom-date {
    border: 1px solid #ff5f00;
    border-radius: 3px;
}

.filterContainer .custom-date i>svg {
    fill: #ff5f00;
}

.filterContainer .custom-date input {
    border: none !important;
}

.filterContainer .custom-date input:focus {
    box-shadow: none !important;
}

button, .btn-trigger {
    background-color: #ff5f00;
    color: #fff;
    padding: 0.3rem 0.5rem;
    border: 1px solid #ff5f00;
    border-radius: 0.2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 0.3rem;
    font-weight: 600;
    white-space: nowrap;
    min-width: fit-content;
    height: 2.2rem;
    transition: 0.5s;
}

.btn-trigger:hover {
    background-color: #e65500;
    border-color: #e65500;
    cursor: pointer;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.reset {
    background-color: #fff;
    color: #ff5f00;
}

.reset:hover {
    cursor: pointer;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.exportBtns {
    display: flex;
    column-gap: 0.5rem;
    justify-self: flex-end;
    align-self: flex-end;
    margin-left: auto;
    font-size: 0.9rem;
}

.exportBtns button {
    color: #ff5f00;
    background-color: #fff0e7;
    border-color: #fff0e7;
}

.exportBtns button:hover {
    cursor: pointer;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
</style>
